<div class="grid">
    <div
      class="flex justify-content-center align-items-center"
      [ngClass]="{ 'col-4 md:col-4 log:col-4 xl:col-4': !mediumSizeFlexColumButton, 'col-4 md:col-12 log:col-4 xl:col-4 md:flex-order-2 xl:flex-order-0': mediumSizeFlexColumButton }"
    >
      <p-button (onClick)="event('-')" label="-" styleClass=""  [disabled]="disabled"></p-button>
    </div>
    <div
      class="flex justify-content-center align-items-center"
      [ngClass]="{ 'col-4 md:col-4 log:col-4 xl:col-4': !mediumSizeFlexColumButton, 'col-4 md:col-12 log:col-4 xl:col-4 md:flex-order-1': mediumSizeFlexColumButton }"
    >
      <div class="p-2" style="border: solid 1px #8C8C8C; border-radius: 5px;">
          {{ ngValue }}
      </div>
    </div>
    <div
      class="flex justify-content-center align-items-center"
      [ngClass]="{ 'col-4 md:col-4 log:col-4 xl:col-4': !mediumSizeFlexColumButton, 'col-4 md:col-12 log:col-4 xl:col-4 md:flex-order-0 xl:flex-order-2': mediumSizeFlexColumButton }"
    >
      <p-button (onClick)="event('+')" label="+" styleClass="" [disabled]="disabled"></p-button>
    </div>
</div>

